<template>
  <component ref="container" :is="containerComponent" :x="x" :y="y" :showOnLeft="showOnLeft" :padding="padding">
    <slot />
  </component>
</template>

<script>
import { clamp } from 'ramda';
import { TooltipContainer } from './tooltip.styles';

export default {
  props: {
    isOpen: { type: Boolean, default: false },
    nodeX: Number,
    nodeY: Number,
    nodeSize: Number,
    targetBox: { type: [DOMRect, Object] },
    padding: { type: Number, default: 8 },
    windowPadding: { type: Number, default: 20 },
    containerComponent: { type: Object, default: () => TooltipContainer },
  },
  data() {
    return { x: 0, y: 0, showOnLeft: false };
  },
  mounted() {
    this.$nextTick(() => {
      const { targetBox } = this;

      if (targetBox.directPosition) {
        this.x = targetBox.x;
        this.y = targetBox.y;
        this.showOnLeft = targetBox.showOnLeft;

        return;
      }

      const { innerWidth: windowWidth } = window;
      const contentBox = this.$refs.container.$el.getBoundingClientRect();

      if (targetBox.centerHorizontally) {
        this.x = targetBox.x + targetBox.width * 0.5 - contentBox.width * 0.5;
        this.y = targetBox.y < contentBox.height ? targetBox.height + 10 : targetBox.y - contentBox.height - 5;

        return;
      }

      const initialX = targetBox.x - contentBox.x - (contentBox.width - targetBox.width) / 2;
      const initialY = targetBox.y - contentBox.y - contentBox.height - this.padding;

      const minX = this.windowPadding;
      const maxX = windowWidth - contentBox.width - this.windowPadding;

      if (minX < maxX) {
        this.x = clamp(minX, maxX, initialX);
      } else {
        this.x = initialX;
      }

      if (initialY < this.windowPadding) {
        this.y = targetBox.y - contentBox.y + targetBox.height + this.padding;
      } else {
        this.y = initialY;
      }
    });
  },
};
</script>
